import { render, staticRenderFns } from "./zoom.vue?vue&type=template&id=b2a17c2e&scoped=true"
import script from "./zoom.vue?vue&type=script&lang=js"
export * from "./zoom.vue?vue&type=script&lang=js"
import style0 from "./zoom.vue?vue&type=style&index=0&id=b2a17c2e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a17c2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2a17c2e')) {
      api.createRecord('b2a17c2e', component.options)
    } else {
      api.reload('b2a17c2e', component.options)
    }
    module.hot.accept("./zoom.vue?vue&type=template&id=b2a17c2e&scoped=true", function () {
      api.rerender('b2a17c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/designCategory/layout/zoom.vue"
export default component.exports